/**
 * Feature flag keys.
 *
 * Add new flags here when building features behind flags.
 * Flag keys must match exactly between frontend and backend/admin UI.
 */
export const FEATURE_FLAGS = {
  // Test flag for coaches - shows Beta badge on Members nav
  TEST_FLAG: 'TEST_FLAG',
  // MEN-4464: restore with the commented All Artifacts nav item if the menu returns.
  // MEMBER_TEST_FLAG: 'MEMBER_TEST_FLAG',
  // Internal manual Drive artifact generation workflow for flagged coaches
  MANUAL_DRIVE_ARTIFACT_GENERATION: 'MANUAL_DRIVE_ARTIFACT_GENERATION',
  // New calendar settings page for connecting calendar accounts and selecting conflict calendars
  NEW_CALENDARS: 'NEW_CALENDARS',
} as const;

export type FeatureFlagKey = keyof typeof FEATURE_FLAGS;

/**
 * Array of all feature flag keys for admin UI dropdown.
 */
export const ALL_FLAG_KEYS: string[] = Object.values(FEATURE_FLAGS);
